import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'clients-license-exipres-soon',
  templateUrl: './license-exipres-soon.component.html',
  styleUrls: ['./license-exipres-soon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenseExipresSoonComponent {}
